<div class="info-block-view">
  <p class="info-block-view__caption">
    Длинный заголовок (обрезка с многоточием, полный текст в заголовке), иконка
    тултипа, сворачивание, одна кнопка «Изменить» — на узком экране у кнопки только
    иконка
  </p>
  <pa-info-block
    [blockTitle]="demoLongBlockTitle"
    tooltip="Расширенная подсказка"
    [isToggleVisible]="true"
    [isContentOpen]="true"
    [headerActions]="headerSingleEdit">
    <p>Содержимое: длинный заголовок обрезается, кнопка в шапке
      слева от стрелки сворачивания.</p>
  </pa-info-block>

  <p class="info-block-view__caption">
    Заголовок, тултип, несколько действий в pa-context-menu (текст и иконки внутри
    выпадающего списка)
  </p>
  <pa-info-block
    blockTitle="Блок с контекстным меню"
    tooltip="Несколько команд собраны под кнопкой с вертикальным многоточием"
    [headerActions]="headerManyActions"
    [isToggleVisible]="true"
  >
    <p>Пункты меню открываются по клику на иконку; подписи видны в контекстном меню.</p>
  </pa-info-block>

  <p class="info-block-view__caption">
    Длинный заголовок без тултипа, меню из двух пунктов, блок изначально свёрнут
  </p>
  <pa-info-block
    blockTitle="Дополнительный сценарий: длинное название секции без иконки вопроса, только меню действий и стрелка"
    [headerActions]="headerComboMenu"
    [isToggleVisible]="true"
    [isContentOpen]="false"
  >
    <p>Контент по умолчанию скрыт; заголовок по-прежнему скрывается многоточием</p>
  </pa-info-block>

  <p class="info-block-view__caption">
    Короткий заголовок, одна кнопка, без сворачивания и без тултипа
  </p>
  <pa-info-block blockTitle="Архивные данные" 
    [headerActions]="headerSingleArchive">
    <p>Когда кнопка свернуть/развернуть нет, действие одно — показывается сразу как кнопка.</p>
  </pa-info-block>

  <pa-info-block blockTitle="Заголовок блока" 
    [isToggleVisible]="true" 
    [isContentOpen]="false">
    <p>Это содержимое блока информации. Здесь может быть любой контент, включая текст, изображения, кнопки и другие компоненты.</p>
  </pa-info-block>

  <pa-info-block blockTitle="Блок с открытым состоянием" 
    [isToggleVisible]="true">
    <p>Это содержимое блока информации. Здесь может быть любой контент, включая текст, изображения, кнопки и другие компоненты.</p>
  </pa-info-block>

  <pa-info-block blockTitle="Информация о пользователе">
    <div>
      <p><strong>Имя:</strong> Иван Петров</p>
      <p><strong>Email:</strong> ivan.petrov&#64;example.com</p>
      <p><strong>Телефон:</strong> +7 (999) 123-45-67</p>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Статистика">
    <div class="stats-grid">
      <div class="stat-item">
        <span class="stat-value">1,234</span>
        <span class="stat-label">Пользователей</span>
      </div>
      <div class="stat-item">
        <span class="stat-value">5,678</span>
        <span class="stat-label">Заказов</span>
      </div>
      <div class="stat-item">
        <span class="stat-value">90%</span>
        <span class="stat-label">Удовлетворенность</span>
      </div>
    </div>
  </pa-info-block>

  <pa-info-block>
    <p>Блок без заголовка - заголовок не отображается, если не передан параметр title.</p>
  </pa-info-block>

  <pa-info-block blockTitle="Блок с кнопками">
    <p>Этот блок содержит кнопки:</p>
    <div class="button-group">
      <pa-button size="small" label="Сохранить"></pa-button>
      <pa-button size="small" severity="secondary" label="Отмена"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Блок с подсказкой"
    tooltip="Это подсказка для блока информации">
    <p>Это содержимое блока информации. Здесь может быть любой контент, включая текст, изображения, кнопки и другие компоненты.</p>
  </pa-info-block>
</div>
